import { useState } from "react";
import { homeService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { useComponentState, useDebounce } from "@miplatform/hooks";
import { buildSearchQuery } from "@miplatform/utils";

export const useCommunitiesViewModel = () => {
  const [communities, setCommunities] = useState([]);

  const stateManager = useComponentState();
  const [search, setSearch] = useState("");
  const debouncedSearch = useDebounce(search, 500);
  const isLoading = stateManager.isBusy();

  const getCommunities = ({ search = "", top, skip } = {}) => {
    const searchQuery = buildSearchQuery(search, ["city/cityName", "name"]);
    return stateManager.run(async () =>
      homeService.communities.getAll({
        sort: "builder/name",
        filters: searchQuery,
        top,
        skip,
      })
    );
  };

  const deleteCommunity = async (data) =>
    stateManager.run(async () => {
      const response = await homeService.communities.deleteCommunity({
        id: data.id,
        modifiedOn: data.modifiedOn,
        toastMessageConfig: {
          success: { text: `${data.name} was deleted.` },
        },
      });

      if (response.status === HTTP_STATUSES.OK) {
        return response;
      }

      return null;
    });

  return {
    getCommunities,
    communities,
    isLoading,
    deleteCommunity,
    search,
    setSearch,
    setCommunities,
    debouncedSearch,
  };
};
